import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getSubscriptionPlans,
  getSubscription,
} from '../../redux/reducers/billing';
import { closeModal } from '../../redux/reducers/modal';
// components
import { Elements, StripeProvider } from 'react-stripe-elements';
import CheckoutForm from './components/CheckoutForm';
import PaymentRequestForm from './components/PaymentRequestForm';
import Preloader from '../../components/Preloader/Preloader';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import BankStatement from './components/BankStatement';
import Pricing from './components/Pricing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faGooglePay, faApplePay } from '@fortawesome/free-brands-svg-icons';
// hoc
import withSizes from 'react-sizes';
// utils
import { toastResponseErrors } from '../../utils/response';
// shapes
import billingShape from '../../shapes/billing';
// styles
import './Billing.css';
import styles from './Billing.mod.css';
import classnames from 'classnames/bind';

export const SUBSCRIPTION_PRICE = 3;
const cx = classnames.bind(styles);

class Billing extends Component {
  state = {
    active: 'card',
  };

  componentDidMount() {
    const { closeModal } = this.props;

    this.props.getSubscriptionPlans().catch(response => {
      toastResponseErrors(response);
      closeModal();
    });
  }

  renderBankStatement = () => (
    <div className={cx('bank-statement-wrapper')}>
      <div className={cx('bank-statement')}>
        <h3>You will be kept anonymous</h3>
        <BankStatement />
      </div>
    </div>
  );

  renderUnsubscribe = () => (
    <div className={cx('unsubscribe-wrapper')}>
      <p>
        To end the subscription - Go to your{' '}
        <span
          className={cx('unsubscribe-link')}
          onClick={this.handlePushToProfile}
        >
          profile page
        </span>
      </p>
    </div>
  );

  handlePushToProfile = () => {
    const { history, isModal, closeModal } = this.props;
    if (isModal) {
      closeModal();
    }
    history.push('/profile');
  };

  render() {
    const {
      subscriptionPlans,
      stripeApiKey,
      isLoading,
      isModal,
      closeModal,
      isTablet,
      isSubscribed,
      getSubscription,
    } = this.props;

    const title = isModal
      ? 'Subscribe to Ladder to get access to the program'
      : 'Billing';

    const unsubscribe = this.renderUnsubscribe();
    const bankStatement = this.renderBankStatement();

    return (
      <PageWrapper
        className={cx('container', {
          'modal-container': isModal,
        })}
      >
        {stripeApiKey === null ? (
          <Preloader isActive={isLoading} />
        ) : (
          <React.Fragment>
            <h2 className={cx('title')}>{title}</h2>
            <h4>Try Ladderout for 7 days - free of charge</h4>
            <p>
              Thereafter only 3$/month - you won't be charged if you cancel your
              subscription withing 7 days
            </p>
            <div className={cx('pay-section')}>
              <div>
                <div className={cx('nav')}>
                  <div
                    className={cx('nav-item', {
                      active: this.state.active === 'card',
                    })}
                    onClick={() => this.setState({ active: 'card' })}
                  >
                    <FontAwesomeIcon icon={faCreditCard} size="2x" />
                    <div>Credit Card</div>
                  </div>
                  <div
                    className={cx('nav-item', {
                      active: this.state.active === 'other',
                      googleApplePay: true,
                    })}
                    onClick={() => this.setState({ active: 'other' })}
                  >
                    <FontAwesomeIcon icon={faGooglePay} size="2x" />
                    <FontAwesomeIcon icon={faApplePay} size="2x" />
                  </div>
                </div>
                {this.state.active === 'card' ? (
                  <StripeProvider apiKey={stripeApiKey}>
                    <Elements>
                      <CheckoutForm
                        isLoading={isLoading}
                        isSubscribed={isSubscribed}
                        isModal={isModal}
                        closeModal={closeModal}
                        isTablet={isTablet}
                        getSubscription={getSubscription}
                        subscriptionPlan={
                          subscriptionPlans && subscriptionPlans[0]
                        }
                      />
                    </Elements>
                  </StripeProvider>
                ) : (
                  <StripeProvider apiKey={stripeApiKey}>
                    <Elements>
                      <PaymentRequestForm
                        isSubscribed={isSubscribed}
                        getSubscription={getSubscription}
                        subscriptionPlan={
                          subscriptionPlans && subscriptionPlans[0]
                        }
                      />
                    </Elements>
                  </StripeProvider>
                )}
              </div>
              <div className={cx('pricing-wrapper')}>
                <div className={cx('pricing')}>
                  <h3>Pricing</h3>
                  <Pricing />
                </div>
              </div>
            </div>
            <div className={cx('statement-section')}>
              {bankStatement}
              {unsubscribe}
            </div>
          </React.Fragment>
        )}
      </PageWrapper>
    );
  }
}

Billing.propTypes = billingShape;

const enhance = compose(
  connect(
    state => ({
      isLoading: state.billing.isLoading,
      subscriptionPlans: state.billing.subscriptionPlans,
      stripeApiKey: state.billing.stripeApiKey,
      isSubscribed: state.auth.user.progress.subscription,
    }),
    { getSubscriptionPlans, getSubscription, closeModal }
  ),

  withSizes(({ width }) => ({
    isTablet: width <= 860,
  }))
);

export default enhance(Billing);



// WEBPACK FOOTER //
// ./src/containers/Billing/Billing.jsx